import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import { Menu as MenuIcon, Home as HomeIcon, Settings as SettingsIcon, Notifications as NotificationsIcon, Person as PersonIcon, LocalOffer as LocalOfferIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { assets } from '../../../assets/assets';
import '../Navbar/Navbar.css';
import { useSelector } from 'react-redux';
import { postData } from '../../../services/apiServices';

function Navbar() {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [profileImage, setProfileImage] = useState();
    const userInfo = useSelector((state) => state.user.userInfo);
    const navigate = useNavigate();
   console.log(userInfo , "> User info")
    const toggleDrawer = (open) => () => {
        setIsDrawerOpen(open);
    };

    const handleClick = (path) => {
        setIsDrawerOpen(false);
        navigate(path);
    };

    const handleLogout = () => {
         console.log("Logout clicked");
         navigate('/');
    };

    useEffect(() => {
        getProfileData();
    }, []);

    const getProfileData = async () => {
        const data = {
            verification_token: "123456",
            table: "Users",
            id: userInfo?.id
        };
        try {
            const result = await postData("/get", data);
            if (result?.message === "success") {
                const mydata = result?.data[0];
                setProfileImage(mydata?.userImage);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="navbar-main">
            <div className="navbar-header">
                <img src={assets.logo} alt="Logo" className="logo" />
            </div>

            <ul className="navbar-menu">
                <li>
                    <a href="/request" onClick={() => handleClick('/request')} className="navbar-link">
                        Requests
                    </a>
                </li>
                <li>
                    <a href="/properties" onClick={() => handleClick('/properties')} className="navbar-link">
                        Properties
                    </a>
                </li>
                <div className="navbar-items">
                    <a href="/setting" onClick={() => handleClick('/setting')} className="navbar-link">
                        <img src={assets.gearImg} alt="Settings" />
                    </a>

                    <a href="/notifications" onClick={() => handleClick('/notifications')} className="navbar-link">
                        <img src={assets.bellImg} alt="Notifications" />
                    </a>

                    <a href="/profile" onClick={() => handleClick('/profile')} className="navbar-link">
                        <img src={profileImage} alt="Profile" className="user-ProfileImg" />
                    </a>
                    <IconButton onClick={toggleDrawer(true)} className="menu-button">
                        <MenuIcon />
                    </IconButton>
                </div>
            </ul>

            {/* Drawer Component */}
            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: '#333333',
                        width: 400,
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                <div className="drawer-image-container">
                    <img
                        src={assets.logowhite} // Replace with your image path
                        alt="Drawer Top"
                        className="drawer-top-image"
                    />
                </div>
                <List sx={{ flexGrow: 1 }}>
                    <ListItem button onClick={() => handleClick('/dashboard')}>
                        <ListItemIcon>
                            <HomeIcon sx={{ color: '#fff' }} />
                        </ListItemIcon>
                        <ListItemText primary="Home" sx={{ color: 'white' }} />
                    </ListItem>

                    <ListItem button onClick={() => handleClick('/setting')}>
                        <ListItemIcon>
                            <SettingsIcon sx={{ color: '#fff' }} />
                        </ListItemIcon>
                        <ListItemText primary="Settings" sx={{ color: '#fff' }} />
                    </ListItem>
{/* 
                    <ListItem button onClick={() => handleClick('/notifications')}>
                        <ListItemIcon>
                            <NotificationsIcon sx={{ color: '#fff' }} />
                        </ListItemIcon>
                        <ListItemText primary="Notifications" sx={{ color: '#fff' }} />
                    </ListItem> */}

                    <ListItem button onClick={() => handleClick('/createOffer')}>
                        <ListItemIcon>
                            <LocalOfferIcon sx={{ color: '#fff' }} />
                        </ListItemIcon>
                        <ListItemText primary="Create Offer" sx={{ color: '#fff' }} />
                    </ListItem>

                    <ListItem button onClick={() => handleClick('/profile')}>
                        <ListItemIcon>
                            <PersonIcon sx={{ color: '#fff' }} />
                        </ListItemIcon>
                        <ListItemText primary="Profile" sx={{ color: '#fff' }} />
                    </ListItem>

                    {userInfo?.usertype !== 'user' &&  userInfo?.usertype !== 'supervisor' &&(
                        <ListItem button onClick={() => handleClick('/allusers')}>
                            <ListItemIcon>
                                <PersonIcon sx={{ color: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary="All Users" sx={{ color: '#fff' }} />
                        </ListItem>
                    )}
                </List>
                
                {/* Logout Button at the bottom */}
                <ListItem button onClick={handleLogout} sx={{ marginTop: 'auto' }}>
                    <ListItemText primary="Logout" sx={{ color: '#fff', textAlign: 'center' }} />
                </ListItem>
            </Drawer>
        </div>
    );
}

export default Navbar;
